import { render, staticRenderFns } from "./LearningRecordStudent.vue?vue&type=template&id=89559028"
import script from "./LearningRecordStudent.vue?vue&type=script&lang=js"
export * from "./LearningRecordStudent.vue?vue&type=script&lang=js"
import style0 from "./LearningRecordStudent.vue?vue&type=style&index=0&id=89559028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports